module.exports = "mutation DeleteImage($id: ID!) {\n  deleteImage(id: $id) {\n    deleted\n  }\n}\n"